import React from "react";
import { Link } from "react-router-dom";

interface AccountItemProps {
  id: string;
  bankName: string;
  accountNumber: string;
  balance: string | number;
}

const AccountItem: React.FC<AccountItemProps> = ({
  bankName,
  accountNumber,
  balance,
}) => (
  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
    <div className="flex items-center space-x-3">
      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
        <svg
          className="w-5 h-5 text-white"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9z" />
        </svg>
      </div>
      <div>
        <p className="text-sm font-semibold text-gray-900">{bankName}</p>
        <p className="text-xs text-gray-500">***{accountNumber.slice(-4)}</p>
      </div>
    </div>
    <span className="text-sm font-bold text-teal-600">
      {balance.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
    </span>
  </div>
);

interface EmptyStateProps {
  message: string;
  actionText: string;
  actionLink: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  actionText,
  actionLink,
}) => (
  <div className="text-center py-8">
    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <svg
        className="w-8 h-8 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
      </svg>
    </div>
    <p className="text-gray-500 text-sm mb-4">{message}</p>
    <Link
      to={actionLink}
      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-red-500 hover:bg-red-600 transition-colors"
    >
      {actionText}
    </Link>
  </div>
);

export { AccountItem, EmptyState };
